import { type HttpClient } from '../useHttpClient';

export const postKickMember =
  (httpClient: HttpClient) => async (channelUrl: string, userId: string) => {
    await httpClient.api(
      `/sendbird/channels/${channelUrl}/users/${userId}/kick`,
      {
        method: 'POST',
      }
    );
  };
